import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import "./i18n";
import { Suspense } from "react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter getUserConfirmation={() => {}}>
    <Provider store={store}>
      <Suspense fallback>
        <App />
      </Suspense>
    </Provider>
  </BrowserRouter>
);
